// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__23GBy","header":"PatientQuestionnaire_header__1CsSe","info":"PatientQuestionnaire_info__1RtyU"};